import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { API, Auth, Router, Store, apiSlice, GlobalContextProvider } from 'app'
import 'bootstrap/dist/css/bootstrap.min.css'

const Main = () => {
  const callApi = API.useAPI()
  useEffect(() => {
    (async () => {
      try {
        const { auth } = await callApi(API.endpoints.INIT)
        Store.dispatch(apiSlice.actions.setSuccess())
        Auth.init(auth)
      } catch (err) {
        Store.dispatch(apiSlice.actions.setError({ errMessage: err.message }))
      }
    })()
  }, [])
  return <></>
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <GlobalContextProvider>
    <Provider store={Store.getStore()}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Main />
        <Router.RouterMap />
      </GoogleOAuthProvider>
    </Provider>
  </GlobalContextProvider>
)
